var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_shadow page_index"},[_c('div',{staticClass:"page pdf-page"},[_c('div',{staticClass:"header"},[_c('span',[_vm._v("Part5")]),_vm._v("学业提升建议\n\t\t")]),_c('div',{staticClass:"jianyi_content"},[_c('p',[_vm._v("【由咨询师填写】a.成绩方面    b.学习状态方面    c.计划方面    d.学习方法掌握方面")])]),_c('div',{staticClass:"big_page_number"})])])
}]

export { render, staticRenderFns }